import { Card, Table, TableContainer, TablePagination } from '@mui/material';
import { useState } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import NoApproval from '../../../assets/app-image/no-approval-posts.svg';
import EllapsedPostGridBody from './ellapsed-post-grid-body.component';
import EllapsedPostGridHead from './ellapsed-post-grid-head.component';

const EllapsedPostGrid = ({ ellapsedPostList, isOrgEvent, handleReCallEllapsedPostPost, order, orderBy,isShowOfferBanner=false  }) => {
  //Table Variables
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [height, setHeight] = useState(window.innerHeight - 110);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    let orderStr = isAsc ? 'desc' : 'asc';
    handleReCallEllapsedPostPost(property, orderStr);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <>
      {ellapsedPostList && ellapsedPostList.length > 0 ? (
        <>
          <DynamicHeightComponent heightRatio={110}>
            <Scrollbar>
              <TableContainer
                sx={{
                  height: isShowOfferBanner ? 'calc(94vh - 226px)' : 'calc(94vh - 226px)',
                }}
              >
                <Table stickyHeader size="small">
                  <EllapsedPostGridHead
                    ellapsedPostList={ellapsedPostList}
                    orderBy={orderBy}
                    order={order}
                    handleRequestSort={handleRequestSort}
                  ></EllapsedPostGridHead>
                  <EllapsedPostGridBody
                    ellapsedPostList={ellapsedPostList}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isOrgEvent={isOrgEvent}
                    handleReCallEllapsedPostPost={handleReCallEllapsedPostPost}
                  ></EllapsedPostGridBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 20, 30, 50]}
                count={ellapsedPostList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Scrollbar>
          </DynamicHeightComponent>
        </>
      ) : (
        <Card
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 150px)',
            maxHeight: 'calc(100vh - 150px)',
          }}
        >
          <img
            src={NoApproval}
            style={{ width: '50%', height: '50%', maxWidth: '50%', maxHeight: '50%' }}
            alt="No Elapsed Approval"
          />
        </Card>
      )}
    </>
  );
};
export default EllapsedPostGrid;
